export const ACURATE_RATE_DECIMAL_DIGIT = 3;
export const ACURATE_RATE_PERCENTAGE_MULTIPLIER = 100;
